<template>
  <div >
      <link href="https://fonts.googleapis.com/css2?family=Turret+Road:wght@500;700&display=swap" rel="stylesheet">

      <div class="wrapper">
          <!-- <span class="title">HODL</span> -->
          <div class="img-wrapper" v-if="!this.$store.state.shake">
                <img src="../assets/hodl.gif" alt="">
          </div>
          <div class="img-wrapper" v-if="this.$store.state.shake">
                <img src="../assets/hodl1.gif" alt="">
          </div>
          <div class="content">
              <span class="typed-text">
              </span>
              <span class="cursor">|</span>
          </div>
      </div>


  </div>
</template>

<script>
export default {
    data() {
        return {
            charIndex: 0,
            textArray: ["Proof of Strong Hands.","Shake Out The Weaks."],
            erasingDelay: 100,
            newTextDelay: 1500,
            typingDelay: 100,
            textIndex: 0,
        }
    },
    methods: {
        typing() {
            const typedText = document.querySelector('.typed-text');
            const cursor = document.querySelector('.cursor')
            
            if (this.charIndex < this.textArray[this.textIndex].length) {

                if (!cursor.classList.contains('typing')) {
                    cursor.classList.add('typing')
                }

                typedText.textContent += this.textArray[this.textIndex].charAt(this.charIndex);
                this.charIndex++;
                setTimeout(this.typing, this.typingDelay);
                
                if(this.textIndex == 0) {
                    this.$store.state.shake = false;
                } else {
                    this.$store.state.shake = true;
                }
            } else {
                cursor.classList.remove('typing')
                setTimeout(this.erasing, this.newTextDelay);
            }
        },
        erasing() {
        const typedText = document.querySelector('.typed-text');
        const cursor = document.querySelector('.cursor')

        if (this.charIndex > 0) {

             if (!cursor.classList.contains('typing')) {
                    cursor.classList.add('typing')
                }

            typedText.textContent = this.textArray[this.textIndex].substring(0,this.charIndex-1);
            this.charIndex--;
            setTimeout(this.erasing, this.erasingDelay);
        } else {
            this.textIndex++;
            if (this.textIndex >= this.textArray.length) {
                this.textIndex = 0;
            }
            cursor.classList.remove('typing')
            setTimeout(this.typing, this.newTextDelay);
            
        }
    },
    },
    mounted() {
        this.typing();
    }
}
</script>

<style lang="scss" scoped>


.wrapper {
    font-family: 'Turret Road', cursive;
    color: white;
    background: black;
    padding: 15em 0;
    max-width: 100;
}

.img-wrapper {
    text-align: center;
}
.title {
    display: grid;
    justify-content: center;
    font-size: 100px;
}

.content {
    display: flex;
    justify-content: center;
}

.typed-text {
    font-size: 35px;
}

// cursor blink animation
.cursor {
    display: inline-block;
    color: white;
    width: 5px;
    animation: blink 0.8s infinite;
    margin-left: 10px;
    font-size: 35px;
}

.typing {
    animation: none;
}

@keyframes blink {
    0% {color: white;}
    49% {color: white;}
    50% {color: black;}
    99% {color: black;}
    100% {color: white;}
}

@media (max-width: 1000px) {
    .img-wrapper {
    img {
        width: 50%;
    }
}
}

@media (max-width: 700px) {
.title {
    font-size: 60px;
}
.typed-text {
    font-size: 20px;
}

.cursor {
 font-size: 20px;
}
}
</style>